import { Diamond } from "lucide-react";

const ITEMS = [
  "Fr. J. Stopa",
  "Amazon KDP",
  "Audible",
  "Theologian",
  "Storyteller",
  "Christian Fiction",
];

export default function Marquee() {
  const row = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-cormorant text-3xl italic text-abbey-cream/70 md:text-5xl">
            {item}
          </span>
          <Diamond className="h-3 w-3 text-abbey-gold/70" fill="currentColor" strokeWidth={1} />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[rgba(212,175,55,0.2)] bg-[#16110D] py-6"
    >
      <div className="flex w-max animate-marquee-drift">
        {row}
        {row}
      </div>
    </div>
  );
}
